import { AssetResponseAssetType } from 'generatedTypes/asset/models';
import { formatToUSDateTimeWith12Hour } from 'utils/dateTimeUtils/dateFormatUtil';

import AssetsGridRowWrapper from 'components/AssetsGrid/components/AssetsGridRowWrapper';
import GridText from 'components/text/GridText';
import TableLink from 'components/text/TableLink';

import usePageRoutes from 'hooks/usePageRoutes';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { Props } from './types';

import styles from './styles.module.scss';

const AssetsGridRow = ({
    assetType,
    id,
    lastActivity,
    lastEdited,
    name,
    ref,
    style,
    testId = TEST_ID
}: Props) => {
    const { batteryDetailsPage, droneDetailsPage } = usePageRoutes();
    const { BATTERY, DRONE } = useTranslation();

    const assetTypeText = assetType === AssetResponseAssetType.BATTERY ? BATTERY : DRONE;

    const getAssetUrl = (assetType: AssetResponseAssetType, id: string) => {
        if (assetType === AssetResponseAssetType.BATTERY) {
            return batteryDetailsPage(id);
        }

        return droneDetailsPage(id);
    };

    return (
        <AssetsGridRowWrapper ref={ref} style={style} testId={testId}>
            <TableLink className={styles.tableLink} text={name} to={getAssetUrl(assetType, id)} />

            <GridText text={assetTypeText} />

            <GridText text={formatToUSDateTimeWith12Hour(lastEdited)} />

            <GridText text={lastActivity ?? '-'} />
        </AssetsGridRowWrapper>
    );
};

export default AssetsGridRow;
